/**
 * Frontend functionality for expanding and closing
 */
function close(content, speed = 300) {

	const startHeight = content.getBoundingClientRect().height

	const animation = [
        { height: startHeight + "px" },
        { height: "0px" }
    ]

    const timing = {
        duration: speed,
        iterations: 1
    }

	const animationObject = content.animate(animation, timing)

    animationObject.addEventListener('finish', () => {
        content.style.height = '0px'
    })
}

function open(content, speed = 300) {

	content.style.height = "auto"
	const finalHeight = content.getBoundingClientRect().height
	content.style.height = "0px"

    const animation = [
        { height: "0px" },
        { height: finalHeight + "px" }
    ]

    const timing = {
        duration: speed,
        iterations: 1
    }

	const animationObject = content.animate(animation, timing)

    animationObject.addEventListener('finish', () => {
        content.style.height = 'auto'
    })
}

function hideEmpty(expander) {

	const hideEmpty = expander.dataset["hideEmpty"]
	if (!hideEmpty) return

	const contentHandle = expander.querySelector(".content")
	if (!contentHandle) return

	if (contentHandle.innerHTML === "") {
		expander.style.display = "none"
		return
	}
}

document.addEventListener("DOMContentLoaded", () => {

	const expanderHandles = document.querySelectorAll(".wp-block-bnd-blocks-bnd-expander")

	for (const handle of expanderHandles) {

		// Check if we need to hide this
		hideEmpty(handle)

		const header = handle.querySelector(".header")
		const content = handle.querySelector(".content")

		// Set initial content as either auto or 0px
		if (content.classList.contains("show")) {
			content.style.height = "auto"
		} else {
			content.style.height = "0px"
		}

		header.addEventListener("click", () => {

			// Check for single open
			if (
				header.getAttribute("data-single-open") &&
				header.getAttribute("data-single-open") === "true"
			) {

				// fetch parent handle as reference
				const parent = header.parentElement.parentElement
				const handles = parent.querySelectorAll(".wp-block-bnd-blocks-bnd-expander")

				// Get the clicked element id
				const clickedID = header.dataset.id

				// close all open handles checking if clicked
				for (const handle of handles) {

					const c = handle.querySelector(".content")
					const h = handle.querySelector(".header")

					const id = h.dataset.id

					// If id matches clicked then just continue and not close
					if (id === clickedID) continue

					h.classList.remove("show")
					close(c)
				}
			}

			// Toggle show
			if (header.classList.contains("show")) {
				header.classList.remove("show")
				content.classList.remove("show")
				close(content)
			} else {
				header.classList.add("show")
				content.classList.add("show")
				open(content)
			}
		})
	}
})
